
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ContentLibraryView from 'common/designer-modules/modules/content-library';
import { generateApiParams, getScrollParent, useContentInitialFetching } from 'common/designer-modules/siteDesigner';
import { isEqual } from 'lodash';

const INITIAL_FILTERS = {
   story: {
      type: 'all',
   },
   store: {
      type: [],
      categories: [],
   },
   media: {
      status: [],
      collections: [],
      casts: [],
      tags: [],
   },
}


const ContentLibrary = ({
   customSiteDesignerData,
   globalSettings,
   getFetchApi,
   collections,
   contentDefaultSorting,
   contentType,
   isMobile,
   resources,
   hasSingleSection,
   isDisabled,
   isNextApp,
   getTheHref,
}) => {
   const contentLibraryRef = useRef(null);
   const getDefaultSettings = () => {
      let defaultFiltersValue = INITIAL_FILTERS[contentType] || INITIAL_FILTERS.media;
      return {
         ...defaultFiltersValue,
         sortBy: contentDefaultSorting, search: '',
      }
   }

   const [media, setMedia] = useState({});
   const [isFetching, setIsFetching] = useState(true);
   const [isNextFetching, setNextIsFetching] = useState(false);
   const [filters, setFilters] = useState(getDefaultSettings());

   const getFetchData = async (initialQuery) => {
      let query = initialQuery;
      if(!initialQuery){
         query = generateApiParams(collections, contentDefaultSorting, contentType, 1);
      }
      setIsFetching(true);
      try {
         const res = await getFetchApi(query, false);
         if(isNextApp){
            setMedia(res);
         } else {
            const { data } = res;
            setMedia(data);
         }
         setIsFetching(false);
      } catch (error) {
         setIsFetching(false);
      }
   }

   useContentInitialFetching(contentLibraryRef, getFetchData, isDisabled)

   useEffect(() => {
      const onScroll = (e) => {
         let elment = document.documentElement;
         if(!isNextApp) elment = e.target

         const { scrollHeight, clientHeight, scrollTop } = elment;
         if(((scrollHeight - scrollTop) - clientHeight < 30)) {
            onNextContent()
         }
      }

      if(hasSingleSection){
         let scrollParent = getScrollParent(!isNextApp);
         if(scrollParent){
            scrollParent.addEventListener('scroll', onScroll)
         }

      }
      return () => {
         if(hasSingleSection){
            let scrollParent = getScrollParent(!isNextApp);

            if(scrollParent){
               scrollParent.removeEventListener('scroll', onScroll)
            }
         }
      }

   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [hasSingleSection, isNextApp, media, isNextFetching])

   const genearteQuery = (newFilters, page = 1) => {
      const sort = newFilters?.sortBy || contentDefaultSorting
      let query = generateApiParams(collections, sort, contentType, page);
      if(newFilters){
         Object.keys(newFilters).forEach((key) => {
            let prefix = ''
            if(key !== 'sortBy' && newFilters[key]){
               let queryValue = newFilters[key];
               if(Array.isArray(newFilters[key])){
                  queryValue = newFilters?.[key].length ? newFilters[key].join(',') : '';
               }
               if(queryValue){
                  query.push(`query[]=${ prefix }${ key }=${ queryValue }`)
               }
            }
         })
      }
      return query;
   }


   const onNextContent = async () => {
      const nextPage = media.current_page + 1
      if(media.last_page < nextPage || isNextFetching) return
      setNextIsFetching(true)
      try {
         const query = genearteQuery(filters, nextPage);
         const res = await getFetchApi(query, false);
         let data = {}
         if(isNextApp){
            data = res
            setMedia(res);
         } else {
            data = res.data
            setMedia(data);
         }
         let newMedia = {
            ...data,
            data: [...media.data, ...data.data],
         }
         setMedia(newMedia);
         setNextIsFetching(false)
      } catch (error) {
         setNextIsFetching(false)

      }
   }

   // Filters and sort

   const onFilterChange = async (name, value, isMultiple = false) => {
      let filterValue = value;
      if(isMultiple){
         filterValue = filters?.[name] || [];
         if(!value){
            filterValue = []
         } else if(filterValue.includes(value)){
            filterValue = filterValue.filter(item => item !== value)
         } else {
            filterValue = [...filterValue, value]
         }
      }
      let newFilters = {
         ...filters,
         [name]: filterValue,
      }
      setFilters(newFilters)
      let query = genearteQuery(newFilters);
      getFetchData(query)
   }

   const clearAllFilters = () => {
      let newFilters = getDefaultSettings();
      setFilters(newFilters)
      let query = genearteQuery(newFilters);
      getFetchData(query)

   }
   return (
      <ContentLibraryView
         contentLibraryRef={ contentLibraryRef }
         customSiteDesignerData={ customSiteDesignerData }
         settings={ customSiteDesignerData }
         title={ customSiteDesignerData.title }
         data={ media }
         type={ contentType }
         isFetching={ isFetching }
         globalSettings={ globalSettings }
         onNextContent={ onNextContent }
         isNextFetching={ isNextFetching }
         isMobile={ isMobile }
         filters={ filters }
         onFilterChange={ onFilterChange }
         resources={ resources }
         hiddeClearFilters={ isEqual(filters, getDefaultSettings()) }
         clearAllFilters={ clearAllFilters }
         showMorePaginationButton={ !hasSingleSection && media.current_page < media.last_page }
         getTheHref={ getTheHref }
         isNextApp={ isNextApp }

      />
   );
}
ContentLibrary.propTypes = {
   customSiteDesignerData: PropTypes.object,
   resources: PropTypes.object,
   globalSettings: PropTypes.object,
   collections: PropTypes.object,
   getFetchApi: PropTypes.func,
   getTheHref: PropTypes.func,
   contentDefaultSorting: PropTypes.string,
   hasSingleSection: PropTypes.bool,
   isNextApp: PropTypes.bool,
   isMobile: PropTypes.bool,
   isDisabled: PropTypes.bool,
   contentType: PropTypes.oneOf([
      'video', 'story', 'store', 'recorded_stream', 'photoset',
   ]),
};

export default ContentLibrary;


